import { axiosInstance } from '../../api';
const BASE_PATH = '/hiring_pipeline';



//Create Pipeline API Call
export let createPipeline = async (pipelineName, position, description, qualificationArray, responsibilityArray, jobType, jobMobility, paidCurrency, location, coverLetter, availableDate, salaryExpectation, customQuestions, salaryPaidBy, reviewCriteria) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/create_pipeline', {
            pipeline_name: pipelineName,
            hiring_position: position,
            job_description: description,
            expected_qualifications: qualificationArray,
            roles_and_responsibilities: responsibilityArray,
            job_type: jobType,
            job_mobility: jobMobility,
            paid_currency: paidCurrency,
            location: location,
            cover_letter: coverLetter,
            available_date: availableDate,
            salary_expectation: salaryExpectation,
            custom_questions: customQuestions,
            salary_paid_by: salaryPaidBy,
            review_criteria: reviewCriteria,
        })
        return value;
    } catch (error) {
        return error
    }
}

//update Pipeline API Call
export let updatePipeline = async (pipelineID, pipelineName, position, description, qualificationArray, responsibilityArray, reviewCriteria, jobType, jobMobility, paidCurrency, location, coverLetter, salaryExpectations, availableDate, customQuestions, salaryPaidBy) => {
    try {

        let value = await axiosInstance.post(BASE_PATH + '/update_job_details', {

            pipeline_id: pipelineID,
            pipeline_name: pipelineName,
            hiring_position: position,
            job_description: description,
            expected_qualifications: qualificationArray,
            roles_and_responsibilities: responsibilityArray,
            review_criteria: reviewCriteria,
            job_type: jobType,
            job_mobility: jobMobility,
            paid_currency: paidCurrency,
            location: location,
            cover_letter: coverLetter,
            salary_expectation: salaryExpectations,
            available_date: availableDate,
            custom_questions: customQuestions,
            salary_paid_by: salaryPaidBy,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Get All Pipelines API Call
export let getAllPipelines = async (state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pipelines', {
            pipeline_state: state
        });
        return value
    } catch (error) {
        return error
    }
}

//Get Pipeline API Call
export let getPipeline = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pipeline', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}

//Get Pipeline for edit API Call
export let getPipelineForEdit = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pipeline_edit', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}

//delete Pipeline  API Call
export let deletePipeline = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/delete_pipeline', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}

//disable Pipeline  API Call
export let disablePipeline = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disable_pipeline', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}

//disable Pipeline  API Call
export let enablePipeline = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reenable_pipeline', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}

//update pipeline Sharablelink status
export let updateShareableLinkStatus = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/update_shareable_link_status', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}

//activate pipeline  
export let activatePipeline = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/activate_pipeline', {
            pipeline_id: pipelineID
        })
        return value
    } catch (error) {
        return error
    }
}


//clone pipeline  
export let clonePipeline = async (pipelineID, newPipelineName) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/clone_pipeline', {
            pipeline_id: pipelineID,
            new_pipeline_name: newPipelineName
        })
        return value
    } catch (error) {
        return error
    }
}

//update pipeline steps order
export let updateOrderOfsteps = async (pipelineID, pipelineSteps) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/update_order_of_steps', {
            pipeline_id: pipelineID,
            pipeline_array : pipelineSteps
        })
        return value
    } catch (error) {
        return error
    }
}

//pinned pipeline 
export let pinnedPipeline = async (pipeline_id, is_pinned) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/pinned_pipeline', {
            pipeline_id: pipeline_id,
            is_pinned : is_pinned
        })
        return value
    } catch (error) {
        return error
    }
}
